import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Container } from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIgetDownloads,
  APIgetDownloadsUsers,
} from '../api/Downloads';

import AdminHeader from '../components/Admin/Header';
import AdminFooter from '../components/Admin/Footer';
import DownloadsList from '../components/Downloads/List';
import DownloadsFilters from '../components/Downloads/Filters';
import EmptyDownloads from './EmptyContainers/Downloads';

import { getVisibleItemsText } from '../helpers';
import { userIsAdmin } from '../helpers/Auth';
import { getUserSetting } from '../helpers/Settings';
import {
  handleComponentParams,
  handleURLParams,
} from '../helpers/URLParams';

import Loading from '../components/Loading';
import ErrorBoundary from '../components/ErrorBoundary';

class Downloads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloads: [],
      downloadsTotal: 0,
      downloadsGlobal: 0,
      selectedUser: null,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      loading: true,
    };

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.loadDownloads = this.loadDownloads.bind(this);
    this.handleUser = this.handleUser.bind(this);
  }

  componentDidMount() {
    handleComponentParams(
      true,
      ['page', 'user_uuid'],
      null,
      this.setState.bind(this),
      (updatedParams) => {
        if (_.has(updatedParams, 'user_uuid')) {
          if (_.has(updatedParams, 'page')) {
            this.handleUser(updatedParams.user_uuid, updatedParams.page);
          } else {
            this.handleUser(updatedParams.user_uuid);
          }
        } else {
          this.loadDownloads();
        }
      },
    );
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'user_uuid'],
      prevProps,
      this.setState.bind(this),
      (updatedParams) => {
        if (_.has(updatedParams, 'user_uuid')) {
          this.handleUser(updatedParams.user_uuid);
        } else {
          this.loadDownloads();
        }
      },
    );
  }

  handleUser(userUuid, page = 1) {
    this.setState({ loading: true });

    if (userUuid === null) {
      this.setState({
        selectedUser: null,
      });
      this.handleChangeUser(null, undefined, page);
    } else {
      APIgetDownloadsUsers().then((res) => {
        const user = res.data.find(u => u.uuid === userUuid);
        if (user) {
          this.setState({
            selectedUser: user,
          });
          this.handleChangeUser(user, undefined, page);
        }
      }).catch(() => {
        this.loadDownloads();
      });
    }
  }

  loadDownloads() {
    const {
      page,
      perPage,
      selectedUser,
    } = this.state;

    this.setState({ loading: true });

    APIgetDownloads({
      user_uuid: selectedUser ? selectedUser.uuid : null,
      page,
      per_page: perPage,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          downloads: data.data,
          downloadsTotal: data.meta.total,
          downloadsGlobal: data.meta.total_global,
        });
      }
    });
  }

  handleChangePage(page) {
    this.setState({ page });
  }

  handleChangeUser(user, _params, page = 1) {
    const { history } = this.props;
    handleURLParams({ user_uuid: user ? user.uuid : null, page }, history);
    this.setState({
      selectedUser: user,
      page,
    }, () => {
      this.loadDownloads();
    });
  }

  render() {
    const {
      selectedUser,
      page,
      perPage,
      downloadsTotal,
      downloadsGlobal,
      loading,
    } = this.state;
    const { intl, profile } = this.props;

    return (
      <div className="main-content downloads-content">
        <Container fluid>
          <AdminHeader
            profile={profile}
            title={`${!userIsAdmin ? intl.formatMessage({ defaultMessage: 'My Downloads' }) :
              intl.formatMessage({ defaultMessage: 'Downloads' })}`}
            icon="fa-download"
            itemName="download"
            itemsTotal={downloadsTotal}
            itemsVisible={getVisibleItemsText(page, perPage, downloadsTotal)}
            showNewItemButton={false}
            loading={loading}
          />
          {(userIsAdmin() && downloadsGlobal > 0) && (
            <DownloadsFilters
              loading={loading}
              selectedUser={selectedUser}
              handleChangeUser={this.handleChangeUser}
            />
          )}
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              <ErrorBoundary>
                {downloadsGlobal === 0 ? (
                  <EmptyDownloads />
                ) : (
                  <>
                    <DownloadsList
                      {...this.state}
                      profile={profile}
                      handleChangeOrder={this.handleChangeOrder}
                      loadDownloads={() => {
                        this.loadDownloads();
                      }}
                    />
                    <AdminFooter
                      {...this.state}
                      itemsTotal={downloadsTotal}
                      handleChangePage={this.handleChangePage}
                    />
                  </>
                )}
              </ErrorBoundary>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

Downloads.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(mapStateToProps)(Downloads)));
